import {
  Alert as MuiAlert,
  AlertProps as MuiAlertProps,
  styled,
} from '@mui/material';
import { ReactComponent as WarningIcon } from '../../assets/images/warning.svg';

interface AlertProps extends MuiAlertProps {
  avatar?: boolean;
}

const StyledAlert = styled(MuiAlert)<MuiAlertProps>(() => ({
  '&.MuiPaper-root.MuiPaper-elevation': {
    borderRadius: '1px',
    padding: '10px 20px',
  },
  '&.MuiAlert-standardWarning': {
    background: '#FEF4D9',
    color: '#FF9900',
  },

  '&.MuiAlert-standardWarning .MuiAlert-icon > svg > path': {
    fill: '#FF9900',
  },

  '&.MuiAlert-standardInfo': {
    background: '#E6F5FF',
    color: '#009FFD',
  },
  '& .MuiAlert-message': {
    padding: '8px 0 6px',
    color: 'inherit',
  },
  '& .MuiAlert-icon': {
    marginRight: 13,
    width: 20,
    height: 20,
    padding: 0,
    display: 'flex',
    alignSelf: 'center',
  },
  '& .MuiAlert-icon > svg': {
    width: 20,
    height: 20,
  },
}));

const StyledAlertAvatar = styled(StyledAlert)<MuiAlertProps>(() => ({
  '& .MuiAlert-icon img': {
    width: 26,
    height: 26,
    borderRadius: '50%',
    padding: 0,
    marginTop: -4,
  },
}));

export function Alert({ avatar, ...props }: AlertProps) {
  return !avatar ? (
    <StyledAlert
      {...props}
      icon={props.severity === 'warning' ? <WarningIcon /> : undefined}
    />
  ) : (
    <StyledAlertAvatar {...props} />
  );
}

export default Alert;
